import { getGradeStyle } from '@aibees/elephant/utils/grade-config';
import { SearchRelevancyGrade } from '@aibees/shared/definition';
import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const circular: SxStyle = {
  position: 'relative',
  display: 'inline-flex',
  cursor: 'pointer',
};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
  minWidth: (p) => p.spacing(36),
};

export const dashed: SxStyle = {
  borderStyle: 'dashed',
};

export const grade: SxStyleFunc<{ grade?: SearchRelevancyGrade }> =
  ({ grade: gradeDraft }) =>
  (theme) => {
    const { color, fontWeight } = getGradeStyle(theme, gradeDraft);
    return {
      color,
      fontSize: theme.typography.body2,
      fontWeight,
    };
  };
